
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "featurePlatformCheckEnabled": true,
  "featureOktaLoginEnabled": false,
  "featureDevModeAvailable": false,
  "npasUrl": "https://npas.vmedia.ca",
  "siteId": "98",
  "baseUrl": "https://a2.vmedia.ca",
  "applicationName": "AMAZON-FIRE",
  "basePath": "./",
  "appVersion": "1.0.62",
  "buildCounter": "848",
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
